<myp-segmented-bar [white]="true" (selected)="selectSection($event.id)" [options]="sections"></myp-segmented-bar>

@if (selectedSection == "list") {
  <div class="m-t-20 m-b-50">
    <div class="d-flex align-items-end flex-wrap">
      <div class="form-group m-r-10">
        <label class="t-12 text-muted mb-0" for="queryType">Search By</label>
        <select class="form-control custom-select-sm" [(ngModel)]="queryType" (ngModelChange)="onQueryTypeChanged()" id="queryType">
          <option value="sku">SKU</option>
          <option value="serial">Serial Number</option>
          <option value="productNo">Product Number</option>
          <option value="bodyType">Body Type</option>
          <option value="series">Series</option>
          <option value="title">Title / Free-text</option>
          <option value="taxonomy">Taxonomy</option>
        </select>
      </div>
      <div class="form-group m-r-20">
        <label class="t-12 text-muted mb-0" for="queryValue">Search Value</label>
        <div class="d-flex align-items-center">
          @if (isTaxonomySearch) {
            <select class="form-control m-r-5" name="queryValue" id="queryValue" [(ngModel)]="queryValue">
              <option value="" disabled>{{ queryPlaceholder }}</option>
              @for (taxonomy of taxonomyOptions; track taxonomy) {
                <option [value]="taxonomy">{{ taxonomy }}</option>
              }
            </select>
          } @else {
            <input class="form-control m-r-5" name="queryValue" id="queryValue" [placeholder]="queryPlaceholder" [(ngModel)]="queryValue" (keyup.enter)="runFenderSearch()" />
          }
          <button class="btn btn-primary" type="button" (click)="runFenderSearch()">
            <fa-icon [icon]="searching ? 'spinner' : 'search'" [animation]="searching ? 'spin' : undefined"></fa-icon>
          </button>
        </div>
      </div>
      @if (!fmicProductsApiEnabled) {
        <div class="form-group m-b-5">
          <label class="t-12 text-muted mb-0">FMIC Products API</label>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="dryRunFmic" [(ngModel)]="dryRunFmic" />
            <label class="form-check-label t-14" for="dryRunFmic">Run dry-run against new API</label>
          </div>
        </div>
      }
    </div>

    @if (isProductSearchType) {
      @if (searching) {
        <myp-inline-loader [loading]="true" height="200px" spinnerName="fenderProductSearchLoader"></myp-inline-loader>
      } @else if (fenderProductResults.length) {
        <div class="m-t-20">
          <div class="text-muted t-14 m-b-10">
            Showing {{ fenderProductResults.length }} result{{ fenderProductResults.length === 1 ? "" : "s" }}{{ fenderProductResultsNextToken ? " (more available)" : "" }}.
          </div>
          @for (row of fenderProductResults; track row.sku) {
            <myp-list-item
              [title]="row.title"
              [subData]="row.subData"
              [photo]="row.imageUrl"
              [showImage]="!!row.imageUrl"
              [imageRound]="false"
              [imageBorder]="false"
              [href]="row.href"
              [metadata]="row.metadata"
              (itemClicked)="onProductRowClicked(row)"
            ></myp-list-item>
            <hr class="m-y-5" />
          }
          @if (fenderProductResultsNextToken) {
            <div class="text-center m-t-20">
              <button class="btn btn-secondary" [disabled]="loadingMore" (click)="loadMoreFenderProducts()">
                @if (loadingMore) {
                  <fa-icon icon="spinner" animation="spin"></fa-icon>
                  Loading more...
                } @else {
                  Load More
                }
              </button>
            </div>
          }
        </div>
      } @else if (queryValue.trim()) {
        <div class="text-muted m-t-30 text-center">No Fender products found for that query.</div>
      }
    }
  </div>
}
@if (selectedSection == "missing_serials") {
  <div class="m-t-20">
    <div class="d-flex flex-wrap m-b-20 align-items-center learn-content-filters" id="filter_options">
      <div class="form-group m-r-10">
        <label class="t-12 text-muted mb-0" for="migrated">Legacy Migrated Gear</label>
        <select class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.migrated" id="migrated">
          <option value="any">Show All</option>
          <option value="yes">Show Migrated</option>
          <option value="no">Hide Migrated</option>
        </select>
      </div>
      <div class="form-group m-r-10">
        <label class="t-12 text-muted mb-0" for="sku">Sku</label>
        <select class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.sku" id="sku">
          <option value="any">Show All</option>
          <option value="yes">Show With SKU</option>
          <option value="no">Show Without SKU</option>
        </select>
      </div>
      <div class="form-group m-r-10">
        <label class="t-12 text-muted mb-0" for="sku">Limit</label>
        <select class="form-control custom-select-sm" (change)="loadMissingSerials(null, true)" [(ngModel)]="pageLimit" id="limit">
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="500">500</option>
          <option value="1000">1000</option>
          <option value="2000">2000</option>
        </select>
      </div>
      <div class="m-r-10">or</div>
      <div class="d-flex">
        <div class="form-group m-r-10">
          <label class="t-12 text-muted mb-0" for="sku">Search By</label>
          <select class="form-control custom-select-sm" [(ngModel)]="queryType" id="queryType">
            <option value="email">Email</option>
            <option value="userId">User ID</option>
            <option value="keyword">Keyword</option>
          </select>
        </div>
        <div class="form-group">
          <label class="t-12 text-muted mb-0" for="sku">Search Value</label>
          <div class="d-flex align-items-center">
            <input
              class="form-control m-r-5"
              name="sku"
              id="sku"
              [placeholder]="queryType == 'email' ? 'Enter email...' : queryType == 'keyword' ? 'Search product names...' : 'Enter a user ID...'"
              [(ngModel)]="queryValue"
              (keyup.enter)="search()"
            />
            <button class="btn btn-primary" type="button" (click)="search()">
              <fa-icon [icon]="searching ? 'spinner' : 'search'" [animation]="searching ? 'spin' : undefined"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    @if (!loading && displayedMissingSerials?.length < missingSerials?.length) {
      <div class="m-y-20">Showing {{ displayedMissingSerials?.length }} of {{ missingSerials?.length }} on this page.</div>
    }
    <myp-inline-loader [loading]="loading" height="400px" spinnerName="loading"></myp-inline-loader>
    @for (ms of displayedMissingSerials; track ms) {
      <myp-missing-serial-item
        [ms]="ms"
        [collapsible]="true"
        [showUserId]="true"
        [savingSku]="savingSku"
        [converting]="converting"
        (onSaveSku)="saveSku($event)"
        (onSerialUpdated)="handleSerialUpdated($event)"
        (onConverted)="handleConverted($event)"
        (onConvert)="convertMissingSerial($event)"
        (onDelete)="deleteMissingSerial($event)"
        (onShowImage)="showImage($event)"
      ></myp-missing-serial-item>
    }
    @if (!loading && !missingSerials?.length && missingSerialKeyword) {
      <div class="m-y-20 text-muted">No product names matching "{{ missingSerialKeyword }}"{{ nextToken ? " on this page" : "" }}.</div>
    }
    @if (!loading && (missingSerials?.length || nextToken)) {
      <myp-paginator
        [offset]="pageOffset"
        [limit]="pageLimit"
        [resultsLength]="missingSerials.length"
        [paginate]="paginate"
        [async]="false"
        [loadingNext]="loadingNext"
        [loadingPrevious]="loadingPrevious"
        [hasNext]="!!nextToken"
      ></myp-paginator>
    }
  </div>
}
